module.exports = __webpack_public_path__ + "img/簡登豪法務.882fa401.jpg";